// eslint-disable-next-line eqeqeq
export const adaptGender = (list, gender) => list.find((item) => item.id == gender);

// eslint-disable-next-line eqeqeq
export const adaptCountry = (list, country) => list.find((item) => item.id == country);

export const adaptOccupancy = (list, occupancy) => list?.find(item => item.id === occupancy);
